<template>
  <div>
    <div v-if="!loaded_publish_info" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'Publish Information'"></order_loader>
      </div>
    </div>
    <div v-else>
      <div v-if="$store.state.orders.order_steps.compliance_terms.partial_order_complete">
        <ValidationObserver ref="orderPublishInfoForm" slim>
          <form role="form" @submit.prevent="order_publish_info_submit">

            <div class="row">
              <div class="col-12">
                <b-card header="Publish Information per Position" header-tag="h4" body-class="mb-3 pb-2 pt-5">
                  <div class="row" id="publish_infos">
                    <div class="col-12">
                      <h5>Each published position has the location and rate prefaced on the job order. Select the orders
                        that need to be published on the website.</h5>
                    </div>
                    <div class="col-12 publish_info" v-for="(p, i) in parseInt(positions.number_of_positions)">
                      <div class="row">
                        <div class="col-12">
                          <h4 class="bp_color">{{ positions.position[p].job_title.job_title }}</h4>
                        </div>

                        <div class="col-12" v-for="(loc, k) in positions.position[p].locations">

                          <div class="row">
                            <label class="col-xl-8 cardLabel font-weight-bold" style="font-size: 0.8rem;"
                              :for="'drce_is_required_' + i + '_' + k">Publish Position at location : {{ loc }}</label>
                            <div class="col-xl-4">
                              <bootstrap-toggle v-model="publish_info[i][k].order_published"
                                :name="'drce_is_required_' + i + '_' + k" :id="'drce_is_required_' + i + '_' + k"
                                :options="{ on: 'Yes', off: 'No' }" />
                            </div>
                          </div>

                          <div v-if="publish_info[i][k].order_published" class="row">
                            <div class="col-xl-12 form-group">
                              <ValidationProvider rules="required" v-slot="{ errors, classes }"
                                :name="'Publish Content ' + i + '_' + k" tag="div">
                                <label class="form-label" :for="'publish_content_' + i + '_' + k">Publish
                                  Content</label>
                                <Editor v-model="publish_info[i][k].publish_text" :id="'publish_content_' + i + '_' + k"
                                  :name="'publish_content_' + i + '_' + k"
                                  api-key="hyqedeskz2k2mylsbkhi8wjlpkdjapoxf0a038m8402qv96x" 
                                  :init="{
                                    height: 500,
                                    menubar: false,
                                    plugins: 'advlist autolink lists link image charmap print preview anchor textcolor colorpicker code paste',
                                    toolbar: 'undo redo | formatselect | fontselect fontsizeselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code',
                                    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                                    font_formats: 'Montserrat=sans-serif,Montserrat; Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Georgia=georgia,palatino,serif; Times New Roman=times new roman,times,serif; Verdana=verdana,geneva,sans-serif',
                                    paste_preprocess: pastePreprocess
                                  }" />

                                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                              </ValidationProvider>
                            </div>
                          </div>

                        </div>

                        <div class="col-12 horizontal_line">
                          <hr>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 offset-xl-6">
                <button class="btn orcaBtn mt-3">Save Publish Information</button>
              </div>
            </div>

          </form>
        </ValidationObserver>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <h5 class="red_color">You must complete all previous sections first before filling out Publish information.
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle';
import order_loader from "loaders/order_loader";

import Editor from '@tinymce/tinymce-vue';

export default {
  name: "publish_information",
  components: {
    BootstrapToggle,
    order_loader,
    Editor,
  },
  data() {
    return {
      loaded_publish_info: false,

      positions: [],
      locations: [],
      publish_info: []
    }
  },
  beforeMount() {
    this.load_data().then(() => this.loaded_publish_info = true);
  },
  methods: {
    load_data() {
      return new Promise(resolve => {
        if (this.$store.state.orders.order_steps.positions_rates.partial_order_complete
          && this.$store.state.orders.order_steps.job_locations.partial_order_complete) {

          this.positions = this.$store.state.orders.order_steps.positions_rates.data;
          this.locations = this.$store.state.orders.order_steps.job_locations.data;

          for (let i = 1; i <= this.positions.number_of_positions; i++) {
            let temp = [];
            for (let j = 0; j < this.positions.position[i].locations.length; j++) {
              let loc = this.locations.site.find(obj => obj.short_site_name === this.positions.position[i].locations[j]);

              let pos_info = null, ess_qual = '', key_resp = '', key_skill_exp = '';
              let h_and_s = '', ppe_tools = '', add_dets = '';
              if (this.positions.position[i].location_specs.find(ls => ls.location === this.positions.position[i].locations[j]) !== undefined) {
                pos_info = this.positions.position[i].location_specs.find(ls => ls.location === this.positions.position[i].locations[j]).position_info;
              }
              if (pos_info !== null && pos_info.essential_qualifications !== null) {
                ess_qual = 'Essential Qualifications required for the position include:' + '<br>';
                pos_info.essential_qualifications.forEach((eq, key, essential_qualifications) => {
                  ess_qual += eq.qualification;
                  if (!(Object.is(essential_qualifications.length - 1, key))) {
                    ess_qual += ', ';
                  }
                })

                ess_qual += '<br><br>';
              }

              if (pos_info !== null && pos_info.key_responsibilities !== null && pos_info.key_responsibilities !== '') {
                key_resp = 'Key Responsibilities for the position include:' + '<br>' + pos_info.key_responsibilities + '<br><br>';
              }

              if (pos_info !== null && pos_info.key_skills_experience !== null && pos_info.key_skills_experience !== '') {
                key_skill_exp = 'Key Skills & Experience required for the position include:' + '<br>' + pos_info.key_skills_experience + '<br><br>';
              }

              if (pos_info !== null && pos_info.health_and_safety !== null && pos_info.health_and_safety !== '') {
                h_and_s = 'Health & Safety for the position:' + '<br>' + pos_info.health_and_safety + '<br><br>';
              }

              if (pos_info !== null && pos_info.ppe_tools !== null && pos_info.ppe_tools !== '') {
                ppe_tools = 'PPS/Tools required for the position:' + '<br>' + pos_info.ppe_tools + '<br><br>';
              }

              if (pos_info !== null && pos_info.additional_details !== null && pos_info.additional_details !== '') {
                add_dets = 'Additional Details for the position:' + '<br>' + pos_info.additional_details + '<br><br>';
              }

              temp.push({
                location: loc.short_site_name,
                job_title: this.positions.position[i].job_title,
                order_published: true,
                publish_text: '' +
                  'Our client is looking for a ' + this.positions.position[i].job_title.job_title +
                  ' to work at a location in ' + loc.address.address_city_town + '<br><br>' +
                  ess_qual + key_resp + key_skill_exp + h_and_s + ppe_tools + add_dets
              })
            }
            this.publish_info.push(temp)
          }
        }

        resolve();
      });
    },
    pastePreprocess(plugin, args) {
      args.content = args.content
        .replace(/[\u2018\u2019]/g, "'")     // smart single quotes → '
        .replace(/[\u201C\u201D]/g, '"')     // smart double quotes → "
        .replace(/\u00A0/g, ' ')             // non-breaking space → space
        .replace(/…/g, '...')                // ellipsis → ...
        .replace(/[^\x20-\x7E\n\r]/g, '');   // remove non-printable ASCII
    },
    order_publish_info_submit() {
      this.$refs.orderPublishInfoForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.orderPublishInfoForm);
          this.$store.commit('SAVE_PUBLISH_INFORMATION_ERRORS', this.publish_info);
        }
        else {
          this.$store.commit('SAVE_PUBLISH_INFORMATION_COMPLETED', this.publish_info);
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
#publish_infos {
  .publish_info {
    &:last-of-type {
      .horizontal_line {
        display: none;
      }
    }
  }
}
</style>
